import { render, staticRenderFns } from "./DM_attainRecord.vue?vue&type=template&id=dcdd85c0&scoped=true&"
import script from "./DM_attainRecord.vue?vue&type=script&lang=js&"
export * from "./DM_attainRecord.vue?vue&type=script&lang=js&"
import style0 from "./DM_attainRecord.vue?vue&type=style&index=0&id=dcdd85c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcdd85c0",
  null
  
)

export default component.exports